module.exports = __webpack_public_path__ + "static/buyer-profile-others-268a545b0826f75db0e084bdd16c5ff5.gif";